import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/modules/material.module';

import { UploadProductsActionComponent } from './upload-products-action/upload-products-action.component';
import { AddProductsActionComponent } from './add-products-action/add-products-action.component';
import { TransferMastersuiteActionComponent } from './transfer-mastersuite-action/transfer-mastersuite-action.component';
import { ExportShootAssetsActionComponent } from './export-shoot-assets-action/export-shoot-assets-action.component';
import { ReleaseCollectionActionComponent } from './release-collection-action/release-collection-action.component';
import { ShareBatchActionComponent } from './share-batch-action/share-batch-action.component';
import { FavouriteBatchActionComponent } from './favourite-batch-action/favourite-batch-action.component';
import { FilterFavouriteActionComponent } from './filter-favourite-action/filter-favourite-action.component';
import { FilterSharedActionComponent } from './filter-shared-action/filter-shared-action.component';

const COMPONENTS = [
  UploadProductsActionComponent,
  AddProductsActionComponent,
  TransferMastersuiteActionComponent,
  ExportShootAssetsActionComponent,
  ReleaseCollectionActionComponent,
  ShareBatchActionComponent,
  FavouriteBatchActionComponent,
  FilterFavouriteActionComponent,
  FilterSharedActionComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, MaterialModule],
  exports: COMPONENTS,
})
export class BatchActionsModule {}
